import {
  Link,
  useLocation,
  useNavigate,
  useRouteLoaderData,
} from "react-router";
import LinkArrow from "../../components/icons/LinkArrow";
import { TEXT } from "../../constants/text";
import ReadMoreContainer from "../../components/ReadMoreContainer";
import { KlientkontoerklaeringByIdLoaderData } from "./KlientkontoerklaeringById";
import { ROUTES } from "../../constants/routes";
import PageError from "../PageError";
import { useEffect } from "react";
import { HomeLoaderResponse } from "../../interfaces/loaders";

export default function IntroKlientkontoerklaering() {
  const navigate = useNavigate();
  const { kke, error } = useRouteLoaderData(
    ROUTES.klientkonto.id,
  ) as KlientkontoerklaeringByIdLoaderData;
  const { userInfo } = useRouteLoaderData(
    ROUTES.homeIndex.id,
  ) as HomeLoaderResponse;
  const location = useLocation();

  useEffect(() => {
    if (userInfo.role === "TokenUser") {
      const kkeId = kke?.id;
      navigate(`/klientkontoerklaering/${kkeId}/tilsvar`);
    }
  }, [navigate, kke, userInfo.role]);

  if (error) return <PageError />;
  if (kke?.status && kke.status !== "Kladde")
    return <PageError msg={`Erklæringen er ${kke.status.toLowerCase()}`} />;
  return (
    <>
      <h1
        className="pb-4
       display-1"
      >
        Klientkontoerklæring
      </h1>
      <div className="row">
        <div className="col-12 col-xl-9">
          <ReadMoreContainer maxLength={12}>
            <p>{TEXT.introKlientkonto.intro}</p>
            <h2 className="display-4 fw-semibold mt-4">
              {TEXT.introKlientkonto.h2_advokat}
            </h2>
            <h3 className="h5 mt-2">{TEXT.introKlientkonto.h3_formular1}</h3>
            <p>{TEXT.introKlientkonto.advokat_text_1}</p>
            <h3 className="h5 mt-2">{TEXT.introKlientkonto.h3_formular2}</h3>
            <p>{TEXT.introKlientkonto.advokat_text_2}</p>
            <h2 className="display-4 fw-semibold mt-4">
              {TEXT.introKlientkonto.h2_advokatselskab}
            </h2>
            <h3 className="h5 mt-2">{TEXT.introKlientkonto.h3_formular1}</h3>
            <p>{TEXT.introKlientkonto.advokatselskab_text_1}</p>
            <h3 className="h5 mt-2">{TEXT.introKlientkonto.h3_formular2}</h3>
            <p>{TEXT.introKlientkonto.advokatselskab_text_2}</p>
            <p className="mt-4">{TEXT.introKlientkonto.outro_1}</p>
            <p>
              {TEXT.introKlientkonto.outro_2}{" "}
              <a
                href={TEXT.introKlientkonto.link_href}
                className="link-primary text-decoration-underline"
                target="_blank"
                rel="noreferrer"
              >
                {TEXT.introKlientkonto.link_text}
              </a>
            </p>
          </ReadMoreContainer>
        </div>
      </div>
      <h3 className="h4 fw-semibold mt-6 mb-4">Vælg formular:</h3>
      <div className="row g-4 align-items-stretch">
        {(kke?.interessentKlienterklaeringMode ===
          "IkkeInteressentKlienterklaering" ||
          kke?.interessentKlienterklaeringMode === "IngenAndresGodkendelser" ||
          ((kke?.interessentKlienterklaeringMode === "AndreHarGodkendt" ||
            kke?.interessentKlienterklaeringMode === "AndreHarIndsendt") &&
            kke?.formularType === "Formular1")) && (
          <div className="col-lg-6 col-12">
            <Link to={`${location.pathname}/tilsvar`} className="card">
              <div className="card-body">
                <div className="d-flex gap-3 align-items-center">
                  <h3 className="display-4 text-body fw-semibold">
                    Erklæring tilsvar
                  </h3>
                  <span className="text-muted ms-auto">Formular I</span>
                  <LinkArrow />
                </div>
              </div>
            </Link>
          </div>
        )}
        {(kke?.interessentKlienterklaeringMode ===
          "IkkeInteressentKlienterklaering" ||
          kke?.interessentKlienterklaeringMode === "IngenAndresGodkendelser" ||
          ((kke?.interessentKlienterklaeringMode === "AndreHarGodkendt" ||
            kke?.interessentKlienterklaeringMode === "AndreHarIndsendt") &&
            kke?.formularType === "Formular2")) && (
          <div className="col-lg-6 col-12">
            <Link to={`${location.pathname}/intet-tilsvar`} className="card">
              <div className="card-body">
                <div className="d-flex gap-3 align-items-center">
                  <h3 className="display-4 text-body fw-semibold">
                    Erklæring - intet tilsvar
                  </h3>
                  <span className="text-muted ms-auto">Formular II</span>
                  <LinkArrow />
                </div>
              </div>
            </Link>
          </div>
        )}
      </div>
    </>
  );
}
